'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  position: relative;\n\n  ', '\n'], ['\n  display: inline-block;\n  position: relative;\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n    &:before {\n      border-bottom: 10px solid rgba(8, 19, 31, 0.5);\n      border-left: 10px solid transparent;\n      border-right: 10px solid transparent;\n      content: \' \';\n      position: absolute;\n      top: 100%;\n      left: calc(50% - 10px);\n    }\n    &:after {\n      border-bottom: 9px solid white;\n      border-left: 9px solid transparent;\n      border-right: 9px solid transparent;\n      content: \' \';\n      position: absolute;\n      top: calc(100% + 2px);\n      left: calc(50% - 9px);\n      z-index: 2;\n    }\n  '], ['\n    &:before {\n      border-bottom: 10px solid rgba(8, 19, 31, 0.5);\n      border-left: 10px solid transparent;\n      border-right: 10px solid transparent;\n      content: \' \';\n      position: absolute;\n      top: 100%;\n      left: calc(50% - 10px);\n    }\n    &:after {\n      border-bottom: 9px solid white;\n      border-left: 9px solid transparent;\n      border-right: 9px solid transparent;\n      content: \' \';\n      position: absolute;\n      top: calc(100% + 2px);\n      left: calc(50% - 9px);\n      z-index: 2;\n    }\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var Wrap = _styledComponents2.default.div(_templateObject, function (props) {
  return props.active && (0, _styledComponents.css)(_templateObject2);
});

exports.default = function (_ref) {
  var active = _ref.active,
      children = _ref.children;
  return _react2.default.createElement(
    Wrap,
    { active: active },
    children
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../thicket/packages/thicket-elements/lib/ShareLink/Trigger.js
// module id = 133
// module chunks = 2